import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

export const RunAgainDialog = ({ course, onClose, onDone }) => {
  const [title, setTitle] = useState("");
  const [copyCohorts, setCopyCohorts] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (course) { setTitle(`${course.title} — ${new Date().getFullYear()}`); setCopyCohorts(false); }
  }, [course]);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/courses/${course.id}/run-again`, { title, copy_cohorts: copyCohorts });
      toast.success(`New course created with ${data.lessons_copied} lesson(s) — it's a draft until you publish it`);
      onDone(data.id);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!course} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="run-again-dialog">
        <DialogHeader>
          <DialogTitle>Run this course again</DialogTitle>
          <DialogDescription>Copies the lessons, assignments and materials into a new draft course. No learners, attendance, marks or due dates are copied.</DialogDescription>
        </DialogHeader>
        <label className="text-xs font-semibold" style={{ color: "var(--sj-text-3)" }}>New course name</label>
        <input data-testid="run-again-title" value={title} onChange={(e) => setTitle(e.target.value)} className="w-full bg-[#EDF2F4] border border-[#EBE9E4] rounded-xl outline-none px-4 py-2.5 text-sm" />
        <label className="flex items-start gap-2 text-sm cursor-pointer mt-1">
          <input data-testid="run-again-copy-cohorts" type="checkbox" checked={copyCohorts} onChange={(e) => setCopyCohorts(e.target.checked)} className="mt-1" />
          <span>Also copy the cohorts and tutors<span className="block text-xs" style={{ color: "var(--sj-text-3)" }}>Class reps are not copied — pick new ones for the next cohort.</span></span>
        </label>
        <DialogFooter>
          <button data-testid="run-again-cancel" onClick={onClose} className="rounded-full px-5 py-2 border text-sm" style={{ borderColor: "var(--sj-border)" }}>Cancel</button>
          <button data-testid="run-again-confirm" disabled={busy || title.trim().length < 2} onClick={go} className="rounded-full px-5 py-2 text-white text-sm font-semibold disabled:opacity-50" style={{ background: "var(--sj-primary)" }}>{busy ? "Creating…" : "Create new course"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
